import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { ApolloQueryResult } from '@apollo/client/core';

@Injectable({ providedIn: 'root' })
export class DataAccessService {
  constructor(private apollo: Apollo) {}

  get<T>(query: DocumentNode, variables?: object): Observable<ApolloQueryResult<T>> {
    const params = {
      query,
      variables
    };

    return this.apollo.query<T>(params);
  }

  update(mutation: DocumentNode, variables?: object): Observable<any> {
    const params = {
      mutation,
      variables
    };

    return this.apollo.mutate(params);
  }
}
